import { render, staticRenderFns } from "./widget-chat.vue?vue&type=template&id=c2074484&"
import script from "./widget-chat.vue?vue&type=script&lang=js&"
export * from "./widget-chat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports